export default {
  placeholder: 'Wybierz kolor',
  color: {
    custom: 'Zwyczaj',
  },
  family: {
    black: 'Czarny',
    gray: 'Szary',
    slate: 'Niebieskoszary',
    red: 'Czerwony',
    orange: 'Pomarańczowy',
    yellow: 'Żółty',
    green: 'Zielony',
    teal: 'Teal',
    cyan: 'Cyjan',
    blue: 'Niebieski',
    indigo: 'Indygo',
    purple: 'Fioletowy',
    pink: 'Różowy',
  },
};
